<template>
  <div>
    <Forms ref="frmSinisterTyping"
      :title="$lang.CarInspection.Typing.TitleForm"
      :showHelp="false"
      :showClearButton="hasRole(this.roles.RW_REG_TABDIGITATION) && !isCompleted"
      :showSaveButton="hasRole(this.roles.RW_REG_TABDIGITATION) && !isCompleted"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <Alerts ref="alert"/>
      <CarInspectionHeader />
      <div class="form-group row"><div class="col-md-12"><hr></div></div>
      <div class="form-group row">
        <div class="col-md-12 intermediate-bar"><i class="fa fa-dollar"></i>&nbsp; VALORES </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <strong>VISTORIAL INICIAL</strong>
        </div>
        <div class="col-md-6">
          <strong>APROVADO SEGURADORA</strong>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-3">
          <label for="txtInitialSurveyBudgetedLabor">Mão de Obra Orçado:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtInitialSurveyBudgetedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.initialSurveyBudgetedLabor.value"
                :size="form.initialSurveyBudgetedLabor.maxlength"
                :required="form.initialSurveyBudgetedLabor.required"
                :state="form.initialSurveyBudgetedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtInitialSurveyApprovedLabor">Peças Orçadas:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtInitialSurveyApprovedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.initialSurveyApprovedLabor.value"
                :size="form.initialSurveyApprovedLabor.maxlength"
                :required="form.initialSurveyApprovedLabor.required"
                :state="form.initialSurveyApprovedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtComplementaryBudgetedLabor">Mão de Obra Aprovada:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtComplementaryBudgetedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.insuranceBudgetedLabor.value"
                :size="form.insuranceBudgetedLabor.maxlength"
                :required="form.insuranceBudgetedLabor.required"
                :state="form.insuranceBudgetedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtComplementaryApprovedLabor">Peças Aprovadas:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa fa-dollar"></i></span>
            <money name="txtComplementaryApprovedLabor"
                class="form-control form-control-10 text-right"
                v-bind="moneyFormat"
                :placeholder="'0,00'"
                prefix="R$ "
                v-model="form.insuranceApprovedLabor.value"
                :size="form.insuranceApprovedLabor.maxlength"
                :required="form.insuranceApprovedLabor.required"
                :state="form.insuranceApprovedLabor.state"
                :disabled="isCompleted">
            </money>
          </div>
        </div>
      </div>
      <div class="form-group row pt-3">
        <div class="col-md-12">
          <label for="txtComments"> {{$lang.CarInspection.Typing.Comments}}:</label>
              <b-form-textarea id="txtComments"
                              name="txtComments"
                              v-model="form.description.value"
                              :rows="form.description.rows"
                              :size="form.description.maxlength"
                              :noResize="form.description.noResize"
                              :disabled="isCompleted"/>
        </div>
      </div>
      <div class="form-group row pt-3">
        <div class="col-md-6">
          <strong>COMPLEMENTOS</strong>
        </div>
        <div class="col-md-6 text-right" v-if="!isCompleted">
          <button type="button" class="btn btn-third btn-sm d-md-down-none" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonNew" @click="onAddComplement"><i class="fa fa-plus-circle"></i>&nbsp; Novo Complemento</button>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <Tables ref="tableGrid"
            :columns="['Mão de Obra Orçado',
                       'Peças Orçadas:',
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            v-on:Load="onLoad">
            <tr v-for="obj in this.objList" v-bind:key="obj.id">
              <TableColumn :IsText="true"   v-on:Edit="onEditComplement(obj)" :status="obj.status" :value="'R$ '+ formatPrice(obj.budgetedLabor)" />
              <TableColumn :IsText="true"   v-on:Edit="onEditComplement(obj)" :status="obj.status" :value="'R$ ' + formatPrice(obj.approvedLabor)" />
              <TableColumn :IsStatus="true" v-on:Edit="onEditComplement(obj)" :status="obj.status" />
              <TableColumn :IsDatetime="true" v-on:Edit="onEditComplement(obj)" :status="obj.status" :value="obj.dateUpdate" />
              <TableColumn :IsText="true"   v-on:Edit="onEditComplement(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
              <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDeleteComplement(obj)" :status="obj.status" />
            </tr>
          </Tables>
        </div>
      </div>
    </Forms>
    <ModalSinisterTyping ref="ModalSinisterTyping" v-on:Reload="onSetAccomplished" />
    <ModalSinisterClosing ref="ModalSinisterClosing" v-on:Closed="onClosed" />
  </div>
</template>
<script>
import SinisterTyping from './sinistertyping.js'

export default SinisterTyping
</script>



// WEBPACK FOOTER //
// src/views/private/inspection/typing/SinisterTyping.vue